const prefix = 'clickable-card';

export const DATA_HOOKS = {
  clickableOverlay: `${prefix}-clickable-overlay`,
} as const;

export const SKIN = {
  standard: 'standard',
  shadow: 'shadow',
  outline: 'outline',
  filled: 'filled',
} as const;
